import BenchlingConfig from 'BenchlingConfig';

interface AutoSaverConfig {
  saveInterval: number;
  maxStale: number;
}

export const getAutoSaverConfig = (): AutoSaverConfig => {
  const saveInterval = BenchlingConfig.ELN_AUTOSAVE_CONFIGURATION.saveIntervalMs;
  const maxStale = Math.ceil(
    BenchlingConfig.ELN_AUTOSAVE_CONFIGURATION.maximumStalenessIntervalMs / saveInterval
  );
  return {saveInterval, maxStale};
};
